export const filterPositiveNumber = (value: string) => {
  const num = Number(value);
  if (!value || Number.isNaN(num) || num < 0) return { num: 0, str: '' };
  return { num, str: value };
};
